<template>
  <div v-if="startup.claim">
    <StickyBlock>
      <b-row class="p-16 border-top">
        <b-col class="d-flex align-items-center justify-content-end">
          <button class="btn px-60" @click="openClaimModal">
            {{ buttonText }}
          </button>
        </b-col>
      </b-row>
    </StickyBlock>
    <ApplicationSentModal
      v-model="isClaimSubmittedModalOpen"
      :success-data="claimSuccessData"
    />
    <StartupClaimModal
      v-model="isModalOpen"
      :startup="startup"
      @submitted="onClaimSubmitted"
    ></StartupClaimModal>
    <ApplicationSentModal
      v-model="isClaimSubmittedModalOpen"
      :success-data="claimSuccessData"
    />
  </div>
</template>

<script>
import StartupClaimModal from '@/modals/startup/StartupClaim'
import ApplicationSentModal from '@/modals/ApplicationSent'
import StickyBlock from '@/components/StickyBlock'

export default {
  name: 'StartupClaim',
  components: {
    ApplicationSentModal,
    StickyBlock,
    StartupClaimModal
  },
  props: {
    startup: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      claimSuccessData: null,
      isModalOpen: false,
      isClaimSubmittedModalOpen: false
    }
  },
  methods: {
    openClaimModal() {
      this.isModalOpen = true
    },
    onClaimSubmitted(successData) {
      this.claimSuccessData = successData
      this.isModalOpen = false
      this.isClaimSubmittedModalOpen = true
    }
  }
}
</script>
